import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';

export class CtRowRenderer extends Component {

    render() {
        const { isEcity, permissionCheck } = this.props;
        const { SalesMargin, RealSalesMargin } = this.props.row;
        if ((isEcity && permissionCheck && (Number(RealSalesMargin) < 14)) || (isEcity && !permissionCheck && (Number(SalesMargin) < 14))) {
            return (
                <div style={{ color: 'red' }}>
                    <ReactDataGrid.Row ref="row" {...this.props} />
                </div>
            );
        } else {
            return (
                <div>
                    <ReactDataGrid.Row ref="row" {...this.props} />
                </div>
            );
        }
    }
}

export default CtRowRenderer;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/ctRowRenderer.jsx